// 查询数据字典
import request from '@/utils/request'

//从环境变量获取auth服务的路径
const VUE_APP_ROLE_PATH = process.env.VUE_APP_ROLE_PATH

//初始化state
const state = {
}
  
  //定义getter
  const getters = {
    
  }

  //定义同步的操作，即mutation
const mutations = {
    
}

//定义异步的操作，即action
const actions = {
    /**
     * @description 获取角色列表
     * @return {Promise}
     */
    // eslint-disable-next-line no-unused-vars
    async getDict({ commit }, dictType) {
        //发起request
        const url = `${VUE_APP_ROLE_PATH}/dict/data/type/${dictType}`;
        const result = await request.get(url);
        //获取服务返回数据
        return result;
    }
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }
